import Loadable from '@townsquare/loadable';

export const ChatLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "chat-view" */ './ChatView'),
	loading: () => null,
});
